export default __webpack_public_path__ + "assets/images/good-00357fe2163b2ea923c3f026b36f3f98.jpg";